import { withFormField } from "@swa-ui/form";

import { DropdownTrigger } from "../DropdownTrigger";

export const DropdownTriggerFormField = withFormField(DropdownTrigger, {
  shouldRegister: false,
});
